
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job/[slugOrId]",
      function () {
        return require("private-next-pages/job/[slugOrId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job/[slugOrId]"])
      });
    }
  